import script from "./FordRiskControlPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FordRiskControlPanel.vue?vue&type=script&setup=true&lang=js"

import "./FordRiskControlPanel.vue?vue&type=style&index=0&id=3f45a3eb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f45a3eb"]])

export default __exports__